import classnames from 'classnames';
import Linker from '@/components/Linker';
import { MyLink } from '@/components/MyLink';
import IconInstagram from './icon_instagram.svg';
import IconFacebook from './icon_facebook.svg';
import IconLinkedIn from './icon_linkedin.svg';
import IconWeb from './icon_web.svg';
import s from './index.module.scss';

export const BrandSocials = ({
  web,
  facebook,
  linkedin,
  instagram,
  className,
}) => {
  if (!web && !facebook && !linkedin && !instagram) return null;

  return (
    <div className={classnames(s.container, className)}>
      {web && (
        <Linker value={web}>
          <img src={IconWeb} alt="web" width={24} height={24} />
        </Linker>
      )}
      {instagram && (
        <MyLink href={instagram} isExternal newWindow>
          <img src={IconInstagram} alt="instagram" width={24} height={24} />
        </MyLink>
      )}
      {linkedin && (
        <MyLink href={linkedin} isExternal newWindow>
          <img src={IconLinkedIn} alt="linkedin" width={24} height={24} />
        </MyLink>
      )}
      {facebook && (
        <MyLink href={facebook} isExternal newWindow>
          <img src={IconFacebook} alt="facebook" width={24} height={24} />
        </MyLink>
      )}
    </div>
  );
};
